import { Container, ErrorBoundary, Skeleton } from 'components';
import React from 'react';

const ResetLayout = React.lazy(() => import('./ResetLayout'));
export const ResetPage = () => {
	return (
		<React.Suspense fallback={<PageSkeleton />}>
			<ErrorBoundary fallback={<PageError />}>
				<ResetLayout />
			</ErrorBoundary>
		</React.Suspense>
	);
};

const PageSkeleton = () => (
	<Container>
		<div className={'flex min-w-[500px] flex-col gap-4'}>
			<Skeleton.Box className={'w-full'} />
			<Skeleton.Box className={'w-1/2'} />
			<Skeleton.Box className={'w-full'} />
			<Skeleton.Box className={'w-1/2'} />
			<Skeleton.Box className={'w-full'} />
		</div>
	</Container>
);
const PageError = () => <div />;
export default ResetPage;
